import inquisitiveLogoPath from 'approot/shared/layout/logo/inquisitive_logo.svg';
import { FooterLogoStyled } from 'approot/shared/layout/footer/footer.style';
import { ScreenReaderOnly } from 'approot/shared/styles/global.styles';

const FooterLogo = () => (
  <FooterLogoStyled>
    <img src={inquisitiveLogoPath} alt="Inquisitive" aria-hidden />
    <ScreenReaderOnly>Inquisitive</ScreenReaderOnly>
  </FooterLogoStyled>
);

export default FooterLogo;
